<template>
    <div class="content">
        <div class="box" v-if="!showVideo">
            <div class="problem-item first-item" @click="openVideo('01如何正确佩戴手表.mp4')">
                1.如何正确佩戴手表
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('02如何开机关机重启手表.mp4')">
                2.如何开机关机重启手表
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('03如何连接手表与手机APP.mp4')">
                3.如何连接手表与手机APP
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('04如何进行指针校准.mp4')">
                4.如何进行指针校准
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('05手表如何接收手机APP推送通知.mp4')">
                5.手表如何接收手机APP推送通知
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('06如何设置手机保活.mp4')">
                6.如何设置手机保活
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('07如何测量心电图.mp4')">
                7.如何测量心电图
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('08如何测量血氧.mp4')">
                8.如何测量血氧
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('09如何开始、暂停、保存运动，以及查看运动详情.mp4')">
                9.如何开始、暂停、保存运动，以及查看运动详情
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('10如何定位更快、更准.mp4')">
                10.如何定位更快、更准
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('11如何锁定与解锁屏幕.mp4')">
                11.如何锁定与解锁屏幕
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('12如何正确测量心率以及查看实时心率.mp4')">
                12.如何正确测量心率以及查看实时心率
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('13如何绑定支付宝.mp4')">
                13.如何绑定支付宝
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('14如何下载、更换、删除表盘.mp4')">
                14.如何下载、更换、删除表盘
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('15如何检查手表版本更新.mp4')">
                15.如何检查手表版本更新
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('16如何正确测量睡眠.mp4')">
                16.如何正确测量睡眠
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('17如何使用APP同步数据.mp4')">
                17.如何使用APP同步数据
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('18如何进行菜单、副屏以及运动设置.mp4')">
                18.如何进行菜单、副屏以及运动设置
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('19如何校准指南针.mp4')">
                19.如何校准指南针
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="problem-item first-item" @click="openVideo('20如何共享数据给家人查看.mp4')">
                20.如何共享数据给家人查看
                <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
        </div>
        <div class="videoPlay" :class="{'video-hide' : !showVideo}" v-if="showVideo">
            <video ref="myVideo" id="video" :src="videoSrc" controls></video>
            <div class="close-video" @click="showVideo = false">返回</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ta700video',
    data() {
        return {
            showVideo: false,
            videoSrc: ''
        }
    },
    mounted() {
    },
    methods: {
        openVideo(name) {
            this.showVideo = true
            this.videoSrc = 'https://service-beidouwatch.obs.cn-southwest-2.myhuaweicloud.com/video700/' + name
            this.$nextTick(() => {
                this.$refs.myVideo.play();
            })
        }
    }
}
</script>

<style scoped>

.content {
    padding-bottom: 20px;
}

.box {
    width: 345px;
    background: var(--bg-color-2);
    opacity: 1;
    border-radius: 13px;
    margin: 10px auto 10px;
    color: var(--text-color-1);
    padding-bottom: 20px;
}

.problem-item {
    padding: 6px 0;
    width: 290px;
    margin: 0 0 0 20px;
    font-size: 15px;
    position: relative;
}

.first-item {
    padding-top: 24px;
}

.last-item {
    padding-bottom: 24px;
}

.to-prob-img {
    position: absolute;
    right: -20px;
    height: 16px;
    top: 15px;
}

.first-item .to-prob-img {
    top: 26px;
}

video {
    width: 345px;
    margin-top: 20px;
    max-height: calc(100% - 120px);
}

.video-hide {
    display: none;
}


.videoPlay {
    /*margin: 0 15px;*/
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
    background: var(--bg-color-1);
    text-align: center;
}

.close-video {
    width: 345px;
    height: 56px;
    border-radius: 13px 13px 13px 13px;
    border: 2px solid #404040;
    position: absolute;
    bottom: 34px;
    left: 15px;
    font-size: 17px;
    color: var(--text-color-1);
    line-height: 56px;
}
</style>


// WEBPACK FOOTER //
// src/views/desc/03ta700video.vue